import { c as _c } from "react/compiler-runtime";
import { toDataDotFilter } from "../utils/helpers";
import { formatNuqsState } from "./lib/format-nuqs-state";
import { useFilterSearchState } from "./use-filtersearch-state";
import { useGeosearchState } from "./use-geosearch-state";
import { useSearchqueryState } from "./use-searchquery-state";
export function useSearchState() {
  const $ = _c(7);
  const [searchQuery] = useSearchqueryState();
  const [geoQuery] = useGeosearchState();
  const [filterQuery] = useFilterSearchState();
  let t0;
  if ($[0] !== filterQuery) {
    t0 = function getQueryState() {
      return toDataDotFilter(formatNuqsState(filterQuery));
    };
    $[0] = filterQuery;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getQueryState = t0;
  let t1;
  if ($[2] !== filterQuery || $[3] !== geoQuery || $[4] !== getQueryState || $[5] !== searchQuery) {
    t1 = {
      searchQuery,
      geoQuery,
      filterQuery,
      getQueryState
    };
    $[2] = filterQuery;
    $[3] = geoQuery;
    $[4] = getQueryState;
    $[5] = searchQuery;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}